export default __webpack_public_path__ + "static/media/benefit_5@3x.2241ac64.png";